var TabMaintenancesModule = /** @class */ (function () {
    function TabMaintenancesModule() {
    }
    return TabMaintenancesModule;
}());
export { TabMaintenancesModule };
